import countries from 'i18n-iso-countries';
import frLocale from 'i18n-iso-countries/langs/fr.json';
import enLocale from 'i18n-iso-countries/langs/en.json';
import esLocale from 'i18n-iso-countries/langs/es.json';

countries.registerLocale(frLocale);
countries.registerLocale(enLocale);
countries.registerLocale(esLocale);

export interface LocalizedOption {
  code: string;
  name: string;
  nameEn?: string;
  nameEs?: string;
}

const ISO_COUNTRY_CODE_PATTERN = /^[A-Z]{2}$/;

/**
 * Resolve the display label for a select option in the active language.
 * Resolution order:
 *   1. Explicit nameEn / nameEs override (if set and language matches)
 *   2. ISO-3166 alpha-2 country code → i18n-iso-countries lookup (en/es only)
 *   3. Fallback to option.name (French)
 */
export function getLocalizedOptionLabel(
  option: LocalizedOption,
  language: string | undefined
): string {
  if (language === 'en' && option.nameEn) return option.nameEn;
  if (language === 'es' && option.nameEs) return option.nameEs;
  if (
    (language === 'en' || language === 'es') &&
    ISO_COUNTRY_CODE_PATTERN.test(option.code)
  ) {
    const isoName = countries.getName(option.code, language);
    if (isoName) return isoName;
  }
  return option.name;
}

/**
 * Direct ISO-3166 alpha-2 code → localized country name lookup.
 * Used by reverse-display helpers (e.g., travel history review screen).
 */
export function getCountryName(
  code: string,
  language: string | undefined
): string {
  const lang =
    language === 'en' || language === 'es' || language === 'fr'
      ? language
      : 'fr';
  return countries.getName(code, lang) ?? code;
}
